import { Injectable, computed, signal } from '@angular/core';
import type { ToastId, ToastRecord } from './toast.model';

@Injectable({ providedIn: 'root' })
export class ToastStore {
  private readonly _toasts = signal<ToastRecord[]>([]);
  private readonly _maxVisible = signal<number>(3);

  public readonly toasts = this._toasts.asReadonly();
  public readonly maxVisible = this._maxVisible.asReadonly();

  /**
   * Render newest first (like Sonner).
   */
  public readonly visibleToasts = computed(() => {
    const all = this._toasts();
    const max = this._maxVisible();
    return all.slice(0, max);
  });

  public setMaxVisible(maxVisible: number): void {
    this._maxVisible.set(Math.max(1, maxVisible));
  }

  public add(toast: ToastRecord): void {
    // Newest first
    this._toasts.update((current) => [toast, ...current]);
  }

  public dismiss(id: ToastId): void {
    this._toasts.update((current) => current.filter((t) => t.id !== id));
  }

  public dismissAll(): void {
    this._toasts.set([]);
  }
}

